import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Pie, Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const TablaSuscripciones = () => {
  const [datos, setDatos] = useState([]);
  const [resumen, setResumen] = useState(null);

  useEffect(() => {
    axios.get('/api/admin/suscripciones')
      .then(res => setDatos(res.data))
      .catch(err => console.error('Error cargando suscripciones:', err));

    axios.get('/api/admin/resumen-suscripciones')
      .then(res => setResumen(res.data))
      .catch(err => console.error('Error cargando resumen:', err));
  }, []);

  // Gráfica de pastel: usuarios premium vs free
  const pieData = {
    labels: ['Premium', 'Free'],
    datasets: [
      {
        data: resumen ? [resumen.usuarios.premium, resumen.usuarios.free] : [],
        backgroundColor: ['#fbbf24', '#60a5fa'], // amarillo y azul
        borderColor: '#fff',
        borderWidth: 2,
      },
    ],
  };

  // Gráfica de barras: suscripciones por mes
  const barData = {
    labels: resumen ? resumen.suscripcionesPorMes.map(item => item.mes) : [],
    datasets: [
      {
        label: 'Suscripciones',
        data: resumen ? resumen.suscripcionesPorMes.map(item => item.total) : [],
        backgroundColor: '#10b981', // verde
      },
    ],
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Suscripciones activas</h2>

      {/* GRÁFICAS */}
        {resumen && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
            {/* Gráfico de pastel */}
            <div className="bg-white rounded-lg shadow p-4 flex flex-col items-center">
                <h3 className="text-lg font-semibold mb-2">Cuentas</h3>
                <Pie data={pieData} />
            </div>

            {/* Cuadro de ingresos */}
            <div className="bg-white rounded-lg shadow p-4 flex flex-col justify-center items-center text-center">
                <h3 className="text-lg font-semibold mb-2">Ingresos</h3>
                <p className="text-sm text-gray-500 mb-1">Totales</p>
                <p className="text-2xl font-bold text-green-600 mb-2">
                ${Number(resumen.ingresos.total).toFixed(2)}
                </p>
                <p className="text-sm text-gray-500">Este mes</p>
                <p className="text-xl font-semibold text-blue-500">
                ${Number(resumen.ingresos.mes_actual).toFixed(2)}
                </p>
            </div>

            {/* Gráfico de barras */}
            <div className="bg-white rounded-lg shadow p-4">
                <h3 className="text-lg font-semibold mb-2 text-center">Suscripciones por mes</h3>
                <Bar data={barData} />
            </div>
            </div>
        )}


      {/* TABLA */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-lg text-sm">
            <thead className="bg-blue-600 text-white">
                <tr>
                <th className="px-4 py-2">Nombre</th>
                <th className="px-4 py-2">Apellidos</th>
                <th className="px-4 py-2">Email</th>
                <th className="px-4 py-2">Estado</th>
                <th className="px-4 py-2">Inicio</th>
                <th className="px-4 py-2">Fin</th>
                <th className="px-4 py-2">Monto</th>
                </tr>
            </thead>
            <tbody>
                {datos.map((item, i) => (
                <tr key={i} className="text-center border-t">
                    <td className="px-4 py-2">{item.name}</td>
                    <td className="px-4 py-2">{item.apellidos}</td>
                    <td className="px-4 py-2">{item.email}</td>
                    <td className="px-4 py-2">{item.estado}</td>
                    <td className="px-4 py-2 text-gray-500">
                    {item.fecha_inicio
                        ? new Date(item.fecha_inicio).toLocaleString('es-MX', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                        })
                        : '-'}
                    </td>
                    <td className="px-4 py-2 text-gray-500">
                    {item.fecha_fin
                        ? new Date(item.fecha_fin).toLocaleString('es-MX', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                        })
                        : '-'}
                    </td>
                    <td className="px-4 py-2">${item.monto} {item.moneda}</td>
                </tr>
                ))}
            </tbody>
            </table>

      </div>
    </div>
  );
};

export default TablaSuscripciones;
